<p-toast></p-toast>

<form [formGroup]="founderForm" (ngSubmit)="onSubmit()">

    <div class="top-main-wrapper">
        <div class="dash-header">
            <div class="dash-title">
                <div class="p-field p-grid">
                    <div class="p-col-8 p-md-8">
                        <h3>{{ id ? 'Edit founder' : 'New founder' }}</h3>
                    </div>
                    <div class="p-col-4 p-md-4">
                        <button pButton pRipple icon="pi pi-save" label="salva" type="submit"
                            class="p-button pull-right p-button-success p-mr-2" [disabled]="isSaving"></button>

                        <button type="button" pButton pRipple icon="pi pi-chevron-left" label=" indietro"
                            class="p-button p-button-back pull-right p-mr-2"
                            [routerLink]="['/admin/founders/']"></button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="main-inner">
        <div class="p-fluid">
            <div class="p-grid">

                <!-- Left column -->
                <div class="p-col-12 p-md-8">

                    <!-- Profile -->
                    <p-card>
                        <ng-template pTemplate="title">Profile</ng-template>

                        <div class="p-field p-grid">
                            <label class="p-col-12 p-md-6">Name <span class="required">*</span>
                                <input type="text" [style]="{ width: '100%' }" pInputText formControlName="name"
                                    placeholder="Jane Doe" />
                                <small *ngIf="submitted && f['name'].errors" class="p-error">Name is required</small>
                            </label>
                            <label class="p-col-12 p-md-6">Slug <span class="required">*</span>
                                <input type="text" [style]="{ width: '100%' }" pInputText formControlName="slug"
                                    placeholder="jane-doe" />
                                <small *ngIf="submitted && f['slug'].errors" class="p-error">Slug is required</small>
                            </label>
                        </div>

                        <div class="p-field p-grid">
                            <label class="p-col-12">Headline
                                <input type="text" [style]="{ width: '100%' }" pInputText formControlName="headline"
                                    placeholder="Founder & CEO at Acme" />
                            </label>
                        </div>

                        <div class="p-field p-grid">
                            <label class="p-col-12 p-md-6">Location
                                <input type="text" [style]="{ width: '100%' }" pInputText formControlName="location"
                                    placeholder="Berlin, Germany" />
                            </label>
                            <label class="p-col-12 p-md-6">Country
                                <p-select [options]="countriesList" [style]="{ width: '100%' }"
                                    formControlName="country" [filter]="true" [showClear]="true"
                                    placeholder="Select country" optionLabel="label" optionValue="label"
                                    appendTo="body"></p-select>
                            </label>
                        </div>

                        <div class="p-field p-grid">
                            <label class="p-col-12">Biography
                                <textarea pInputTextarea rows="6" [style]="{ width: '100%' }"
                                    formControlName="biography"
                                    placeholder="Tell the founder's story, background and what they are building..."></textarea>
                            </label>
                        </div>
                    </p-card>

                    <br />

                    <!-- Companies -->
                    <p-card formArrayName="companies">
                        <ng-template pTemplate="title">
                            <div class="p-d-flex p-jc-between">
                                <span>Companies</span>
                                <button type="button" pButton pRipple icon="pi pi-plus" label="Connect startup"
                                    class="p-button p-button-outline pull-right p-button-sm"
                                    (click)="addCompany()"></button>
                            </div>
                        </ng-template>

                        <p *ngIf="companies.length === 0" class="text-muted">
                            Connect the startups this founder built and set their role in each one.
                        </p>

                        <div *ngFor="let group of companies.controls; let i = index" [formGroupName]="i"
                            class="repeat-card p-mb-3">
                            <div class="p-field p-grid">
                                <label class="p-col-12 p-md-5">Startup <span class="required">*</span>
                                    <p-select [options]="startupsList" [style]="{ width: '100%' }"
                                        formControlName="startup_id" optionLabel="startup_name" optionValue="id"
                                        [filter]="true" filterBy="startup_name" placeholder="Select startup"
                                        appendTo="body"></p-select>
                                </label>
                                <label class="p-col-12 p-md-4">Role <span class="required">*</span>
                                    <p-select [options]="roleOptions" [style]="{ width: '100%' }" formControlName="role"
                                        [editable]="true" placeholder="e.g. Co-Founder & CEO"
                                        appendTo="body"></p-select>
                                </label>
                                <label class="p-col-12 p-md-2">Year
                                    <input type="text" [style]="{ width: '100%' }" pInputText formControlName="year"
                                        placeholder="2021" />
                                </label>
                                <div class="p-col-12 p-md-1 p-d-flex p-ai-end">
                                    <button type="button" pButton icon="pi pi-times"
                                        class="p-button p-button-danger p-button-outline"
                                        (click)="remove(companies, i)"></button>
                                </div>
                            </div>
                        </div>
                    </p-card>

                    <br />

                    <!-- Exits -->
                    <p-card formArrayName="exits">
                        <ng-template pTemplate="title">
                            <div class="p-d-flex p-jc-between">
                                <span>Exits</span>
                                <button type="button" pButton pRipple icon="pi pi-plus" label="Add exit"
                                    class="p-button p-button-outline pull-right p-button-sm"
                                    (click)="addExit()"></button>
                            </div>
                        </ng-template>

                        <p *ngIf="exits.length === 0" class="text-muted">Acquisitions, mergers or IPOs.</p>

                        <div *ngFor="let group of exits.controls; let i = index" [formGroupName]="i"
                            class="repeat-card p-mb-3">
                            <div class="p-field p-grid">
                                <label class="p-col-12 p-md-6">Company <span class="required">*</span>
                                    <input type="text" [style]="{ width: '100%' }" pInputText formControlName="company"
                                        placeholder="Company name" />
                                </label>
                                <label class="p-col-12 p-md-6">Acquirer
                                    <input type="text" [style]="{ width: '100%' }" pInputText formControlName="acquirer"
                                        placeholder="Acquired by" />
                                </label>
                                <label class="p-col-12 p-md-3">Year
                                    <input type="text" [style]="{ width: '100%' }" pInputText formControlName="year"
                                        placeholder="2022" />
                                </label>
                                <label class="p-col-12 p-md-3">Amount
                                    <input type="text" [style]="{ width: '100%' }" pInputText formControlName="amount"
                                        placeholder="$10M" />
                                </label>
                                <label class="p-col-12 p-md-5">Description
                                    <input type="text" [style]="{ width: '100%' }" pInputText
                                        formControlName="description" placeholder="Short note" />
                                </label>
                                <div class="p-col-12 p-md-1 p-d-flex p-ai-end">
                                    <button type="button" pButton icon="pi pi-times"
                                        class="p-button p-button-danger p-button-outline"
                                        (click)="remove(exits, i)"></button>
                                </div>
                            </div>
                        </div>
                    </p-card>

                    <br />

                    <!-- Investments -->
                    <p-card formArrayName="investments">
                        <ng-template pTemplate="title">
                            <div class="p-d-flex p-jc-between">
                                <span>Investments</span>
                                <button type="button" pButton pRipple icon="pi pi-plus" label="Add investment"
                                    class="p-button p-button-outline pull-right p-button-sm"
                                    (click)="addInvestment()"></button>
                            </div>
                        </ng-template>

                        <p *ngIf="investments.length === 0" class="text-muted">Startups this founder has invested in.
                        </p>

                        <div *ngFor="let group of investments.controls; let i = index" [formGroupName]="i"
                            class="repeat-card p-mb-3">
                            <div class="p-field p-grid">
                                <label class="p-col-12 p-md-6">Company <span class="required">*</span>
                                    <input type="text" [style]="{ width: '100%' }" pInputText formControlName="company"
                                        placeholder="Company name" />
                                </label>
                                <label class="p-col-12 p-md-6">Stage
                                    <input type="text" [style]="{ width: '100%' }" pInputText formControlName="stage"
                                        placeholder="Seed, Series A..." />
                                </label>
                                <label class="p-col-12 p-md-3">Year
                                    <input type="text" [style]="{ width: '100%' }" pInputText formControlName="year"
                                        placeholder="2023" />
                                </label>
                                <label class="p-col-12 p-md-3">Amount
                                    <input type="text" [style]="{ width: '100%' }" pInputText formControlName="amount"
                                        placeholder="$50K" />
                                </label>
                                <label class="p-col-12 p-md-5">URL
                                    <input type="url" [style]="{ width: '100%' }" pInputText formControlName="url"
                                        placeholder="https://" />
                                </label>
                                <div class="p-col-12 p-md-1 p-d-flex p-ai-end">
                                    <button type="button" pButton icon="pi pi-times"
                                        class="p-button p-button-danger p-button-outline"
                                        (click)="remove(investments, i)"></button>
                                </div>
                            </div>
                        </div>
                    </p-card>

                    <br />

                    <!-- Startup timeline -->
                    <p-card formArrayName="startup_timeline">
                        <ng-template pTemplate="title">
                            <div class="p-d-flex p-jc-between">
                                <span>Startup timeline</span>
                                <button type="button" pButton pRipple icon="pi pi-plus" label="Add milestone"
                                    class="p-button p-button-outline pull-right p-button-sm"
                                    (click)="addTimelineItem()"></button>
                            </div>
                        </ng-template>

                        <p *ngIf="startupTimeline.length === 0" class="text-muted">
                            Key milestones in the founder's journey.
                        </p>

                        <div *ngFor="let group of startupTimeline.controls; let i = index" [formGroupName]="i"
                            class="repeat-card p-mb-3">
                            <div class="p-field p-grid">
                                <label class="p-col-12 p-md-3">Year
                                    <input type="text" [style]="{ width: '100%' }" pInputText formControlName="year"
                                        placeholder="2020" />
                                </label>
                                <label class="p-col-12 p-md-8">Title <span class="required">*</span>
                                    <input type="text" [style]="{ width: '100%' }" pInputText formControlName="title"
                                        placeholder="Launched first product" />
                                </label>
                                <div class="p-col-12 p-md-1 p-d-flex p-ai-end">
                                    <button type="button" pButton icon="pi pi-times"
                                        class="p-button p-button-danger p-button-outline"
                                        (click)="remove(startupTimeline, i)"></button>
                                </div>
                                <label class="p-col-12">Description
                                    <input type="text" [style]="{ width: '100%' }" pInputText
                                        formControlName="description" placeholder="What happened" />
                                </label>
                            </div>
                        </div>
                    </p-card>

                    <br />

                    <!-- Interviews -->
                    <p-card formArrayName="interviews">
                        <ng-template pTemplate="title">
                            <div class="p-d-flex p-jc-between">
                                <span>Interviews</span>
                                <button type="button" pButton pRipple icon="pi pi-plus" label="Add interview"
                                    class="p-button p-button-outline pull-right p-button-sm"
                                    (click)="addInterview()"></button>
                            </div>
                        </ng-template>

                        <p *ngIf="interviews.length === 0" class="text-muted">Podcasts, videos and interviews.</p>

                        <div *ngFor="let group of interviews.controls; let i = index" [formGroupName]="i"
                            class="repeat-card p-mb-3">
                            <div class="p-field p-grid">
                                <label class="p-col-12">Title <span class="required">*</span>
                                    <input type="text" [style]="{ width: '100%' }" pInputText formControlName="title"
                                        placeholder="Interview title" />
                                </label>
                                <label class="p-col-12 p-md-4">Source
                                    <input type="text" [style]="{ width: '100%' }" pInputText formControlName="source"
                                        placeholder="Publication" />
                                </label>
                                <label class="p-col-12 p-md-4">Date
                                    <input type="text" [style]="{ width: '100%' }" pInputText formControlName="date"
                                        placeholder="2024" />
                                </label>
                                <label class="p-col-12 p-md-3">URL
                                    <input type="url" [style]="{ width: '100%' }" pInputText formControlName="url"
                                        placeholder="https://" />
                                </label>
                                <div class="p-col-12 p-md-1 p-d-flex p-ai-end">
                                    <button type="button" pButton icon="pi pi-times"
                                        class="p-button p-button-danger p-button-outline"
                                        (click)="remove(interviews, i)"></button>
                                </div>
                            </div>
                        </div>
                    </p-card>

                    <br />

                    <!-- Articles -->
                    <p-card formArrayName="articles">
                        <ng-template pTemplate="title">
                            <div class="p-d-flex p-jc-between">
                                <span>Articles</span>
                                <button type="button" pButton pRipple icon="pi pi-plus" label="Add article"
                                    class="p-button p-button-outline pull-right p-button-sm"
                                    (click)="addArticle()"></button>
                            </div>
                        </ng-template>

                        <p *ngIf="articles.length === 0" class="text-muted">Articles and press mentions.</p>

                        <div *ngFor="let group of articles.controls; let i = index" [formGroupName]="i"
                            class="repeat-card p-mb-3">
                            <div class="p-field p-grid">
                                <label class="p-col-12">Title <span class="required">*</span>
                                    <input type="text" [style]="{ width: '100%' }" pInputText formControlName="title"
                                        placeholder="Article title" />
                                </label>
                                <label class="p-col-12 p-md-4">Source
                                    <input type="text" [style]="{ width: '100%' }" pInputText formControlName="source"
                                        placeholder="Publication" />
                                </label>
                                <label class="p-col-12 p-md-4">Date
                                    <input type="text" [style]="{ width: '100%' }" pInputText formControlName="date"
                                        placeholder="2024" />
                                </label>
                                <label class="p-col-12 p-md-3">URL
                                    <input type="url" [style]="{ width: '100%' }" pInputText formControlName="url"
                                        placeholder="https://" />
                                </label>
                                <div class="p-col-12 p-md-1 p-d-flex p-ai-end">
                                    <button type="button" pButton icon="pi pi-times"
                                        class="p-button p-button-danger p-button-outline"
                                        (click)="remove(articles, i)"></button>
                                </div>
                            </div>
                        </div>
                    </p-card>
                </div>

                <!-- Right column -->
                <div class="p-col-12 p-md-4">
                    <p-card>
                        <ng-template pTemplate="title">Publish</ng-template>

                        <div class="p-field p-grid">
                            <label class="p-col-12">Status
                                <p-select [options]="[
                                    { label: 'active', value: 1 },
                                    { label: 'not active', value: 0 }
                                ]" [style]="{ width: '100%' }" formControlName="status" optionLabel="label"
                                    optionValue="value" appendTo="body"></p-select>
                            </label>
                        </div>
                    </p-card>

                    <br />

                    <p-card>
                        <ng-template pTemplate="title">Social links</ng-template>

                        <div class="p-field p-grid">
                            <label class="p-col-12">Website
                                <input type="url" [style]="{ width: '100%' }" pInputText formControlName="website"
                                    placeholder="https://" />
                            </label>
                            <label class="p-col-12">Twitter / X
                                <input type="url" [style]="{ width: '100%' }" pInputText formControlName="twitter"
                                    placeholder="https://x.com/" />
                            </label>
                            <label class="p-col-12">LinkedIn
                                <input type="url" [style]="{ width: '100%' }" pInputText formControlName="linkedin"
                                    placeholder="https://linkedin.com/in/" />
                            </label>
                            <label class="p-col-12">GitHub
                                <input type="url" [style]="{ width: '100%' }" pInputText formControlName="github"
                                    placeholder="https://github.com/" />
                            </label>
                            <label class="p-col-12">Product Hunt
                                <input type="url" [style]="{ width: '100%' }" pInputText formControlName="producthunt"
                                    placeholder="https://producthunt.com/@" />
                            </label>
                            <label class="p-col-12">Instagram
                                <input type="url" [style]="{ width: '100%' }" pInputText formControlName="instagram"
                                    placeholder="https://instagram.com/" />
                            </label>
                        </div>
                    </p-card>
                </div>
            </div>

            <input type="hidden" formControlName="id" />
        </div>
    </div>
</form>